<template>
  <div class="general-tab-cards">
    <accordion-panel
      id="cooling-efficiency-cards"
      class="general-tab-cards__cards-accordion"
      :collapsed.sync="collapsed"
    >
      <template #title>
        {{ $t('general.general') }}
      </template>
      <s-loader
        v-if="loading"
        class="my-5"
        size="lg"
      />
      <div
        v-else-if="cards.length"
        class="general-tab-cards__cards-wrapper avoid-break"
      >
        <div
          v-for="(card, index) in cards"
          class="general-tab-cards__card"
          :key="card.name"
          :class="getCardClass(card.situation)"
        >
          <div class="general-tab-cards__card-sensor">
            <sensor-icon
              :detail="card"
              :unique-id="createId()"
            />
          </div>
          <div class="general-tab-cards__card-icon">
            <cooling-efficiency-situation-icon
              v-if="!card.situation.includes('normal')"
              :situation="card.situation"
              :parameter="card.parameter"
              :card-id="index"
            />
          </div>
          <div class="text-center">
            <span class="general-tab-cards__card-value">
              <s-number
                fallback-value="-"
                :value="card.value"
              />
            </span>
            <span class="general-tab-cards__card-unit">
              {{ card.unit }}
            </span>
          </div>
          <div class="general-tab-cards__card-name">
            {{ card.name }}
          </div>
        </div>
      </div>
      <s-empty-list
        v-else
      />
    </accordion-panel>
  </div>
</template>

<script>
import AccordionPanel from '@/components/AccordionPanel';
import SensorIcon from '@/domain/components/installation/engineering/SensorIcon';
import { createId } from '@/services/createId';
import CoolingEfficiencySituationIcon
  from '@/domain/components/installation/engineering/coolingEfficiency/CoolingEfficiencySituationIcon';
import { CoolingEfficiencySituations } from 'sigma-mappings';

export default {
  name: 'GeneralTabCardsSection',
  props: {
    cards: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AccordionPanel,
    SensorIcon,
    CoolingEfficiencySituationIcon,
  },
  data: () => ({
    createId,
    collapsed: false,
  }),
  methods: {
    getCardClass(situation) {
      const highAlarmClass = 'general-tab-cards__high-alarm-card';
      const veryHighAlarmClass = 'general-tab-cards__very-high-alarm-card';
      const icons = {
        [CoolingEfficiencySituations.HIGH_ALARM_IMMINENT]: highAlarmClass,
        [CoolingEfficiencySituations.HIGH_ALARM_ACTUATED]: highAlarmClass,
        [CoolingEfficiencySituations.VERY_HIGH_ALARM_IMMINENT]: veryHighAlarmClass,
        [CoolingEfficiencySituations.VERY_HIGH_ALARM_ACTUATED]: veryHighAlarmClass,
        [CoolingEfficiencySituations.NORMAL]: '',
      };
      return icons[situation];
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"

$very-high-alarm: var(--color-danger)
$high-alarm: var(--color-warning)

.general-tab-cards
  &__cards-accordion
    box-shadow: none

  &__cards-wrapper
    width: 100%
    display: grid
    gap: 18px
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr))

  &__card
    position: relative
    padding: 10px
    border: 1px solid var(--color-border-dark)
    border-radius: 5px
    min-height: 160px
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center

  &__very-high-alarm-card
    border: none !important
    box-shadow: 0 0 3px $very-high-alarm, inset 0 0 3px $very-high-alarm !important

  &__high-alarm-card
    border: 1px solid $high-alarm

  &__card-sensor,
  &__card-icon
    height: 28px
    position: absolute
    top: 5px
    right: 7px

  &__card-value
    font-size: 2.5em

  &__card-unit
    font-size: 1.8em

  &__card-name
    text-align: center
    margin-top: 10px
    font-size: .9em
    font-weight: bold

  ::v-deep
    .accordion-panel
      &__header
        padding: 2px 15px !important
        font-weight: bold
</style>
